const n = (value) => Number(value);
const isFiniteNumber = (value) => Number.isFinite(n(value));

export const validateBusinessCase = (values) => {
  const warnings = {};

  const checkNonNegative = (key, label) => {
    const value = n(values[key]);
    if (!isFiniteNumber(values[key]) || value < 0) {
      warnings[key] = `${label} must be zero or greater.`;
    }
  };

  [
    ["appointmentsRequired", "Appointments required"],
    ["successfulRailwayHires", "Successful Railway Careers UK hires"],
    ["campaignsPerYear", "Comparable campaigns per year"],
    ["conventionalApplicationsReceived", "Applications received"],
    ["conventionalGatewayPass", "Applications passing automatic gateway"],
    ["conventionalOperationalShortlist", "Candidates sent to operational shortlisting"],
    ["conventionalInterviewed", "Candidates interviewed"],
    ["talentProfilesReviewed", "Talent Pool profiles reviewed"],
    ["talentOperationalShortlist", "Talent Pool candidates sent to operational shortlisting"],
    ["talentInterviewed", "Talent Pool candidates interviewed"],
    ["candidatesPerInterviewDay", "Candidates per interview day"],
    ["weeklyContractedHours", "Weekly contracted hours"],
    ["productiveWeeksPerYear", "Productive weeks per year"],
  ].forEach(([key, label]) => checkNonNegative(key, label));

  if (n(values.appointmentsRequired) < 1) {
    warnings.appointmentsRequired = "Appointments required must be at least one.";
  }

  if (n(values.successfulRailwayHires) > n(values.appointmentsRequired)) {
    warnings.successfulRailwayHires = "Successful Railway Careers UK hires cannot exceed appointments required.";
  }

  if (n(values.successfulRailwayHires) > n(values.talentInterviewed)) {
    warnings.successfulRailwayHires = "Successful Railway Careers UK hires cannot exceed Talent Pool candidates interviewed.";
  }

  if (n(values.talentInterviewed) > n(values.talentOperationalShortlist)) {
    warnings.talentInterviewed = "Talent Pool interviewed candidates cannot exceed talent operational shortlist.";
  }

  if (n(values.conventionalInterviewed) > n(values.conventionalOperationalShortlist)) {
    warnings.conventionalInterviewed = "Conventional interview attendees cannot exceed operational shortlist volume.";
  }

  if (n(values.conventionalOperationalShortlist) > n(values.conventionalGatewayPass)) {
    warnings.conventionalOperationalShortlist = "Operational shortlist cannot exceed gateway pass volume.";
  }

  if (n(values.conventionalGatewayPass) > n(values.conventionalApplicationsReceived)) {
    warnings.conventionalGatewayPass = "Gateway pass volume cannot exceed applications received.";
  }

  if (n(values.talentOperationalShortlist) > n(values.talentProfilesReviewed)) {
    warnings.talentOperationalShortlist = "Talent operational shortlist cannot exceed profiles reviewed.";
  }

  if (n(values.candidatesPerInterviewDay) < 1) {
    warnings.candidatesPerInterviewDay = "Candidates per interview day must be at least one.";
  }

  if (n(values.productiveWeeksPerYear) > 52) {
    warnings.productiveWeeksPerYear = "Productive weeks cannot exceed 52.";
  }

  if (n(values.weeklyContractedHours) <= 0) {
    warnings.weeklyContractedHours = "Weekly contracted hours must be greater than zero.";
  }

  if (n(values.productiveWeeksPerYear) <= 0) {
    warnings.productiveWeeksPerYear = "Productive weeks must be greater than zero to calculate loaded hourly rates.";
  }

  if (n(values.talentInterviewed) > 0 && n(values.successfulRailwayHires) === n(values.talentInterviewed)) {
    warnings.talentConversionAssumption =
      "This scenario assumes 100% conversion from Talent Pool interview to successful hire. Consider testing a more conservative conversion rate.";
  }

  return warnings;
};
